module.exports = __webpack_public_path__ + "img/paint-brush-fine.a32ce449.svg";